/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_DurationInputs */



/**
* | output |
* | --- |
* | "Job Duration" |
*
* @param {Job_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const job_duration = /** @type {((inputs?: Job_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée de la tâche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Beschäftigungsdauer")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata del lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Продолжительность работы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración del trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("工作时长")
	if (locale === "ja") return /** @type {LocalizedString} */ ("仕事の期間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नौकरी की अवधि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração do trabalho")
	return /** @type {LocalizedString} */ ("Job Duration")
});